const setActionBar = ({
  text,
  setActionBarText,
  hideActionBar,
  showActionBar
}) => {
  setActionBarText(text)
  showActionBar()

  setTimeout(() => {
    hideActionBar()
  },2600)
}

export default setActionBar